import { render, staticRenderFns } from "./LoginApim.vue?vue&type=template&id=a232353a&"
import script from "./LoginApim.vue?vue&type=script&lang=js&"
export * from "./LoginApim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports